"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Balance = void 0;
var _react = _interopRequireDefault(require("react"));
var _state = require("../../../../../../state");
var _Context = require("./Context");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Balance = function Balance(_ref) {
  var children = _ref.children,
    name = _ref.name;
  return /*#__PURE__*/_react.default.createElement(_Context.Context.Provider, {
    value: {
      useBalances: _state.useBalances,
      balanceName: name
    }
  }, children);
};
exports.Balance = Balance;